import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { OpenConversationType } from '@/types/events/open-conversation.ts';

export default function openConversation(data: OpenConversationType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);
  conversationsStore.addNewCacheMessage(data.logMessage);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
    conversationsStore.addNewMessage(data.logMessage);
  }
}
